import React, { useEffect, useState } from 'react';
import Select from "react-select";

import { useDispatch, useSelector } from "react-redux";
import { getLegacyDepartamentos } from "../../slices/thunks";
import { setDepartamento } from '../../slices/context/reducer';

const DepartamentoSelector = () => {
    const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(null);
    const [departamentos, setDepartamentos] = useState([])
    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const departamentosSelector = useSelector((state) => state.LegacyDepartamentos.legacyDepartamentos)
    const userInfo = useSelector((state) => state.UserInfo.userInfo)
    const dispatch = useDispatch();

    function parseDepartamento(departamento) {
        return { value: departamento?.CENRES, label: departamento?.nombre };
    }

    useEffect(() => {
        if (Array.isArray(departamentosSelector) && departamentosSelector?.length > 0) {
            setDepartamentos(departamentosSelector)
            let opcion = parseDepartamento(departamentosSelector[0])
            setDepartamentoSeleccionado(opcion);
            dispatch(setDepartamento(opcion.value))
        }
    }, [departamentosSelector]);

    useEffect(() => {
        if (userInfo?.name && tenantId && empresa) {
            dispatch(getLegacyDepartamentos({ tenantId, usuario: userInfo?.name, empresa }))
        }
    }, [userInfo, tenantId, empresa])

    const handleSelectDepartamento = (opcion) => {
        setDepartamentoSeleccionado(opcion);
        dispatch(setDepartamento(opcion.value));
    };

    return (
        <React.Fragment>
            <Select
                id="departamentos"
                placeholder="Departamentos..."
                value={departamentoSeleccionado}
                onChange={(opcion) => {
                    handleSelectDepartamento(opcion);
                }}
                options={departamentos?.map(parseDepartamento)}
                onFocus={(e) => {
                    e.target.readOnly = true;
                }}
            />
        </React.Fragment>
    );
};

export default DepartamentoSelector;